var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoFuel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.334,
    height: 38.756,
    viewBox: "0 0 36.334 38.756",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_56996",
    "data-name": "Grupo 56996",
    transform: "translate(12.111 20.892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43362",
    "data-name": "Caminho 43362",
    d: "M180.542,288.111A4.547,4.547,0,0,1,176,283.57c0-.624.178-1.76,1.718-4.415.778-1.341,1.545-2.455,1.578-2.5a1.514,1.514,0,0,1,2.491,0c.032.047.8,1.16,1.578,2.5,1.54,2.655,1.718,3.791,1.718,4.415A4.547,4.547,0,0,1,180.542,288.111Zm0-7.784q-.1.164-.2.335a8.329,8.329,0,0,0-1.317,2.91,1.514,1.514,0,0,0,3.028,0,8.411,8.411,0,0,0-1.326-2.925Q180.635,280.484,180.542,280.327Z",
    transform: "translate(-176 -276)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_56997",
    "data-name": "Grupo 56997"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43363",
    "data-name": "Caminho 43363",
    d: "M146.6,80h-6.056A4.547,4.547,0,0,0,136,84.542V87.57a4.547,4.547,0,0,0,4.542,4.542H146.6a4.547,4.547,0,0,0,4.542-4.542V84.542A4.547,4.547,0,0,0,146.6,80Zm1.514,7.57a1.516,1.516,0,0,1-1.514,1.514h-6.056a1.516,1.516,0,0,1-1.514-1.514V84.542a1.516,1.516,0,0,1,1.514-1.514H146.6a1.516,1.516,0,0,1,1.514,1.514Z",
    transform: "translate(-126.917 -73.944)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43364",
    "data-name": "Caminho 43364",
    d: "M50.117,10.781,46.278,6.943V6.056A6.063,6.063,0,0,0,40.223,0H25.083a6.063,6.063,0,0,0-6.056,6.056V35.728H17.514a1.514,1.514,0,0,0,0,3.028H47.792a1.514,1.514,0,0,0,0-3.028H46.278V32.743a4.54,4.54,0,0,0,6.056-4.281V16.134A7.52,7.52,0,0,0,50.117,10.781Zm-.811,17.68a1.514,1.514,0,0,1-3.028,0V21.195h3.028Zm0-10.295H44.764a1.514,1.514,0,0,0-1.514,1.514V35.728H22.056V6.056a3.031,3.031,0,0,1,3.028-3.028H40.223A3.031,3.031,0,0,1,43.25,6.056v7.57a1.514,1.514,0,1,0,3.028,0v-2.4l1.7,1.7a4.512,4.512,0,0,1,1.33,3.211Z",
    transform: "translate(-16)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFuel);
export default __webpack_public_path__ + "static/media/ico-fuel.43f9ead055287765d4684ba20969a364.svg";
export { ForwardRef as ReactComponent };